import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

type PasswordInputProps = {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: string;
  required?: boolean;
  minLength?: number;
  "data-testid"?: string;
};

export const PasswordInput = ({
  id,
  value,
  onChange,
  autoComplete,
  required,
  minLength,
  "data-testid": testId,
}: PasswordInputProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <input
        id={id}
        type={visible ? "text" : "password"}
        className="w-full h-10 pl-3 pr-10 border border-black/15 bg-white text-sm focus:outline-none focus:ring-1 focus:ring-black"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        required={required}
        minLength={minLength}
        data-testid={testId}
      />
      <button
        type="button"
        onClick={() => setVisible((current) => !current)}
        className="absolute right-0 top-0 h-10 w-10 inline-flex items-center justify-center text-vg-gray hover:text-vg-ink transition-colors"
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        data-testid={testId ? `${testId}-toggle` : undefined}
      >
        {visible ? <EyeOff size={18} strokeWidth={1.75} /> : <Eye size={18} strokeWidth={1.75} />}
      </button>
    </div>
  );
};

export default PasswordInput;
